<app-deprecated-confirmation-dialog #dialog label="delete" [negative]="true"></app-deprecated-confirmation-dialog>
